var dijkstra = require("./dijkstra"),
    _ = require("../lodash");

module.exports = dijkstraAll;

function dijkstraAll(g, weightFunc, edgeFunc) {
  return _.transform(g.nodes(), function(acc, v) {
    acc[v] = dijkstra(g, v, weightFunc, edgeFunc);
  }, {});
}



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/alg/dijkstra-all.js
// module id = 966
// module chunks = 0